import { mergeLocaleData } from '@b-stock/fe-core/locale'
import { payUiEnLocaleData } from '@b-stock/fe-core/pay-ui'

// Runtime shim: common.en.json's strings are spread at the message-ID ROOT
// (e.g. `back`, `edit`) with no filename prefix, which the filename-based
// generator cannot produce — so these ~51 keys stay nested here and are
// flattened at runtime (negligible cost). See scripts/locale-roots.js.
import commonEn from './translations/en/common.json'
// Precompiled (flattened) map of the per-module locale JSON under translations/en/.
// Generated + gitignored; regenerated automatically on dev/build/lint/test. The
// keys are already dot-flattened (e.g. `SignIn.title`); mergeLocaleData passes
// already-dotted keys through untouched while it flattens the nested shim below.
import precompiledEn from './translations/en/modules.flattened.generated'

const localeData = mergeLocaleData({
  en: { ...commonEn, ...precompiledEn, ...payUiEnLocaleData },
})

export default localeData
